/*
 * Copyright (c) 2019 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.statistics', {
            parent: 'board',
            url: '/board/statistics',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.memberManagement.statistics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/statistics/statistics.html',
                    controller: 'StatisticsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('member-management');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('manager-project-detail', {
            parent: 'board.statistics',
            url: '/manager/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.memberManagement.statistics.project.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/statistics/manager-project-overview.html',
                    controller: 'ManagerProjectOverviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    return MemberManagement.get({id : $stateParams.id}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('member-management');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('project');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
